import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { LayoutService } from "../../layout.service";
import { CommonService } from "@app/shared/common/common.service";

declare var $: any;
@Component({
  selector: 'sa-setting-menu',
  templateUrl: './setting-menu.component.html'
})
export class SettingMenuComponent implements OnInit {
  currentUrl: string;

  constructor(private router: Router, private layoutService: LayoutService, private commonService: CommonService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.router.url.indexOf("/settings/") !== -1) {   
          localStorage.setItem("appDetail",JSON.stringify({ code: "settings", showDefault: false }));
          this.layoutService.triggerAppDataChange({ code: "settings", showDefault: false });
        }
      }
    });
  }

  ngOnInit() {
    // this.onClickSettings();
    // this.layoutService.triggerAppDataChange({ code: "settings", showDefault: true });
    this.currentUrl = window.location.href.replace(window.location.origin,'')
    this.layoutService.triggerAppDataChange({ code: "settings", showDefault: true , path: this.currentUrl});
  }

  onClickSettings() {
    if (this.router.url.indexOf("/settings/") !== -1) {
      this.layoutService.triggerAppDataChange({ code: "purchase", showDefault: true, path: "/purchase/overview" });
    } else {
      this.layoutService.triggerAppDataChange({ code: "settings", showDefault: true });
      //this.router.navigate(['/settings/usermanager/myprofile']);
    }
  }


}
